import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

import { sanitizeSvgHtml } from '@helpers/sanitization';

@Injectable({
  providedIn: 'root',
})
export class SvgIconService {
  private iconRegistry: MatIconRegistry = inject(MatIconRegistry);
  private sanitizer: DomSanitizer = inject(DomSanitizer);

  public addSvgIcon(iconName: string, svgContent: string): void {
    const sanitizedSvg = sanitizeSvgHtml(svgContent);
    if (!sanitizedSvg) {
      throw new Error(`SVG icon "${iconName}" is empty or invalid.`);
    }
    this.iconRegistry.addSvgIconLiteral(iconName, this.createTrustedSvg(sanitizedSvg));
  }
  /**
   * * Security boundary.
   * * The value passed here has already been sanitized by
   * * sanitizeSvgHtml() using an SVG-specific allowlist and
   * * validated to contain a single SVG root element.
   * */
  private createTrustedSvg(sanitizedSvg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedSvg); //NOSONAR
  }
}
